import theme from "../../../theme"

export const useCopilotStyles = () => {
  return {
    viewTitle: {
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'flex-end',
      borderBottom: `1px solid ${theme.palette.divider}`,
      fontWeight: 500,
      pb: '.1125rem',
      marginRight: '1rem',
      background: '#fff'
    },
    bottomPanel: {
      overflowY: 'scroll', 
      height: `calc(100% - 2rem)`, 
      width: '100%',
      padding: '1rem 0'
    },
    promptInput: {
      marginBottom: '1rem',
      width: 'calc(100% - 8.5rem)',
      padding: '0px',
      '& .MuiOutlinedInput-input': {
        padding: '.5rem 1rem',
      },
      '& .MuiInputLabel-root': {
        transform: 'translate(1rem, .5rem) scale(1)'
      },
      '& .MuiInputLabel-shrink': {
        transform: 'translate(.875rem, -.375rem) scale(0.75)',
      },
    },
    contextInput: {
      marginBottom: '1rem',
      width: '100%',
      padding: '0px',
      '& .MuiInputBase-root': {
        padding: '0',
      },
      '& .MuiInputBase-input': {
        padding: '.75rem',
      },
      '& .MuiOutlinedInput-inputMultiline': {
        padding: '.75rem',
      },
    },
    buttonApply: {
      margin: '0 .25rem',
      border: '1px solid',
      width: '8rem',
      height: '2.3rem',
    },
    buttonAnalyze: {
      ml: '.5rem',
      border: '1px solid',
      width: '5rem',
      height: '2.3rem',
    },
    buttonSave: {
      margin: '0 .25rem',
      border: '1px solid',
      width: '8rem',
      height: '2.5rem',
    },
    selectStoredFilter: {
      padding: '0px',
      '.MuiOutlinedInput-input': {
        padding: '.75rem',
      },
    },
    storedFilters: {
      float: 'right',
      display: 'flex',
      flexDirection: 'row',
      maxWidth: 'calc(100% - 15rem)',
    },
    select: {
      padding: '0px',
      '.MuiOutlinedInput-input': {
        padding: '.375rem 1rem',
      },
      '& .MuiInputLabel-shrink': {
        transform: 'translate(.875rem, -.375rem) scale(0.75)',
      },
    },
    textField: {
      width: 'calc(100% - 11rem)',
      padding: '0',
      '& .MuiOutlinedInput-input': {
        padding: '.5rem 1rem',
      },
      '& .MuiInputLabel-root': {
        transform: 'translate(1rem, .5rem) scale(1)'
      },
      '& .MuiInputLabel-shrink': {
        transform: 'translate(.875rem, -.375rem) scale(0.75)',
      },
    }
  }
}